export default __webpack_public_path__ + "static/media/87t.9cf1e0f5.jpg";